<script setup lang="ts">
withDefaults(defineProps<{ dark?: boolean }>(), { dark: false })
</script>
<template>
  <div
    class="w-min rounded-full p-2 shadow-xl"
    :class="{ 'bg-zinc-500': dark, 'bg-white': !dark }"
  >
    <SvgoLoading
      class="size-6 animate-spin text-zinc-800"
      :class="{ 'text-zinc-200': dark, 'text-zinc-800': !dark }"
    />
  </div>
</template>
